
    <div>
      <h1>404: page missing</h1>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/no-content/no-content.component.ts.NoContentComponent.html